module.exports = __webpack_public_path__ + "img/cat-empty-educacion.5b1fedca.svg";